export * from './get-office-equipments-input';
export * from './office-equipment-input';
export * from './office-equipment-result';